import {
  ButtonCheckbox,
  InputCheckboxChangeEvent,
} from '../../../../../services/MarppleShop/renderApp/components/atoms/ButtonCheckbox/ButtonCheckbox';
import { isMembershipSupported } from '../../../../Util/S/Function/membership';
import { font } from '../../../../../services/MarppleShop/shared/typography';

export class MembershipFilter extends ButtonCheckbox {
  readonly onChangeEvent = InputCheckboxChangeEvent;

  constructor(data: { active: boolean }) {
    super({
      ...data,
      name: 'MembershipFilter',
      label: '멤버십 상품',
      font_klass: font('14_regular', '12_regular'),
    });
  }

  static isVisible() {
    return isMembershipSupported();
  }
}
